{
  "common": {
    "loading": "Cargando...",
    "error": "Error",
    "success": "Correcto",
    "info": "Información",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Guardar",
    "saved": "Guardado",
    "delete": "Eliminar",
    "edit": "Editar",
    "create": "Crear",
    "search": "Buscar",
    "back": "Atrás",
    "next": "Siguiente",
    "done": "Hecho",
    "yes": "Sí",
    "no": "No",
    "ok": "OK",
    "retry": "Reintentar",
    "close": "Cerrar",
    "submit": "Enviar",
    "update": "Actualizar",
    "remove": "Quitar",
    "add": "Añadir",
    "view": "Ver",
    "share": "Compartir",
    "copy": "Copiar",
    "copied": "¡Copiado!",
    "noResults": "No se encontraron resultados",
    "pullToRefresh": "Desliza para actualizar",
    "clearFilters": "Limpiar filtros",
    "noResultsFilters": "No hay resultados con estos filtros",
    "tryAdjustingFilters": "Prueba a ajustar tu búsqueda o filtros",
    "all": "Todos",
    "seeMore": "Ver más",
    "seeLess": "Ver menos"
  },
  "navigation": {
    "myTournaments": "Mis Torneos",
    "explore": "Explorar Torneos",
    "friends": "Amigos",
    "friendRequests": "Solicitudes de Amistad",
    "challenges": "Desafíos",
    "followers": "Seguidores",
    "following": "Siguiendo",
    "feed": "Actividad",
    "settings": "Ajustes",
    "profile": "Perfil",
    "logout": "Cerrar Sesión",
    "searchUsers": "Buscar Usuarios",
    "leagues": "Mis Ligas",
    "tournamentsSection": "Torneos",
    "leaguesSection": "Ligas",
    "exploreLeagues": "Explorar Ligas",
    "home": "Inicio",
    "invitations": "Invitaciones",
    "joinByCode": "Unirse por Código",
    "feedback": "Enviar Feedback",
    "teams": "Mis Equipos",
    "teamsSection": "Equipos",
    "exploreTeams": "Explorar Equipos",
    "createTeam": "Crear Equipo",
    "blog": "Blog",
    "whatsNew": "Novedades",
    "trainerPassSection": "TrainerPass",
    "trainerPassLeaderboard": "Clasificación",
    "myLaunches": "Mis Lanzamientos"
  },
  "auth": {
    "welcomeBack": "Bienvenido de nuevo",
    "signInToContinue": "Inicia sesión para continuar",
    "createAccount": "Crear Cuenta",
    "joinTournaly": "Únete a Tournaly y empieza a competir",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "confirmPassword": "Confirmar contraseña",
    "fullName": "Nombre completo",
    "signIn": "Iniciar Sesión",
    "signUp": "Registrarse",
    "signOut": "Cerrar Sesión",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "resetPassword": "Restablecer Contraseña",
    "dontHaveAccount": "¿No tienes una cuenta?",
    "alreadyHaveAccount": "¿Ya tienes una cuenta?",
    "legalPrefix": "Al registrarte, aceptas nuestros",
    "legalAnd": "y",
    "loginRequired": "Inicio de Sesión Requerido",
    "loginRequiredMessage": "Necesitas iniciar sesión para realizar esta acción.",
    "login": "Iniciar Sesión",
    "enterEmail": "Introduce tu correo electrónico",
    "enterPassword": "Introduce tu contraseña",
    "enterFullName": "Introduce tu nombre completo",
    "passwordsDontMatch": "Las contraseñas no coinciden",
    "invalidCredentials": "Credenciales inválidas",
    "loginFailed": "Error de Inicio de Sesión",
    "signUpFailed": "Error de Registro",
    "resetPasswordSent": "Correo de restablecimiento enviado",
    "checkEmail": "Revisa tu correo para las instrucciones",
    "setNewPassword": "Establecer Nueva Contraseña",
    "enterNewPassword": "Introduce tu nueva contraseña a continuación",
    "newPassword": "Nueva Contraseña",
    "confirmNewPassword": "Confirmar Nueva Contraseña",
    "updatePassword": "Actualizar Contraseña",
    "passwordUpdated": "Tu contraseña ha sido actualizada correctamente",
    "invalidResetLink": "Este enlace de restablecimiento no es válido o ha expirado. Por favor, solicita uno nuevo.",
    "forgotPasswordSubtitle": "Introduce tu correo para recibir un enlace de restablecimiento",
    "sendResetLink": "Enviar Enlace",
    "backToLogin": "Volver al Inicio de Sesión"
  },
  "tournaments": {
    "tournament": "Torneo",
    "tournaments": "Torneos",
    "createTournament": "Crear Torneo",
    "editTournament": "Editar Torneo",
    "deleteTournament": "Eliminar Torneo",
    "tournamentName": "Nombre del Torneo",
    "description": "Descripción",
    "rules": "Reglas",
    "tournamentRules": "Reglas del Torneo",
    "tournamentType": "Tipo de Torneo",
    "singleElimination": "Eliminación Simple",
    "doubleElimination": "Doble Eliminación",
    "roundRobin": "Todos contra Todos",
    "swiss": "Sistema Suizo",
    "maxParticipants": "Máximo de Participantes",
    "startDate": "Fecha de Inicio",
    "location": "Ubicación",
    "locationOptional": "Ubicación (opcional)",
    "public": "Público",
    "private": "Privado",
    "publicTournament": "Torneo Público",
    "privateTournament": "Torneo Privado",
    "status": "Estado",
    "setup": "Configuración",
    "inProgress": "En Progreso",
    "completed": "Completado",
    "participants": "Participantes",
    "participant": "Participante",
    "noParticipantsYet": "Aún no hay participantes",
    "addParticipant": "Añadir Participante",
    "addParticipants": "Añade participantes para iniciar el torneo",
    "enterParticipantName": "Introduce el nombre del participante",
    "addRegisteredUser": "Añadir Usuario Registrado",
    "startTournament": "Iniciar Torneo",
    "generating": "Generando...",
    "viewBracket": "Ver Cuadro",
    "bracket": "Cuadro",
    "standings": "Clasificación",
    "admins": "Administradores",
    "settings": "Ajustes",
    "champion": "Campeón",
    "winner": "Ganador",
    "loser": "Perdedor",
    "match": "Partido",
    "round": "Ronda",
    "seed": "Cabeza de Serie",
    "score": "Puntuación",
    "vs": "vs",
    "bye": "Bye",
    "tbd": "Por definir",
    "invalidParticipantCount": "Número de participantes inválido. Necesita potencia de 2 (2, 4, 8, 16...)",
    "currently": "Actualmente",
    "tournamentCreated": "¡Torneo creado!",
    "tournamentUpdated": "¡Torneo actualizado!",
    "tournamentDeleted": "¡Torneo eliminado!",
    "failedToCreate": "Error al crear el torneo",
    "failedToUpdate": "Error al actualizar el torneo",
    "failedToDelete": "Error al eliminar el torneo",
    "failedToLoad": "Error al cargar el torneo",
    "tournamentNotFound": "Torneo no encontrado",
    "tournamentPrivate": "Este torneo es privado",
    "tournamentMayBePrivate": "Este torneo puede ser privado o ya no existe",
    "follow": "Seguir",
    "following": "Siguiendo",
    "unfollow": "No seguir",
    "followers": "seguidores",
    "full": "Lleno",
    "noTournamentsYet": "Aún no hay torneos",
    "createFirstTournament": "¡Crea tu primer torneo!",
    "enterName": "Introduce el nombre",
    "enterDescription": "Introduce la descripción",
    "descriptionOptional": "Descripción (Opcional)",
    "required": "*",
    "singleEliminationDesc": "Una derrota = eliminado. Formato rápido.",
    "doubleEliminationDesc": "Dos derrotas = eliminado. Segunda oportunidad.",
    "roundRobinDesc": "Todos contra todos. Por puntos.",
    "swissDesc": "Emparejamiento por puntuación. Sin eliminación.",
    "tripleElimination": "Triple Eliminación",
    "tripleEliminationDesc": "3 derrotas antes de eliminar.",
    "tripleEliminationParticipantsFixed": "Requiere exactamente 4 participantes. El número de participantes es fijo para este formato.",
    "kingOfTheHill": "Rey de la Colina",
    "kingOfTheHillDesc": "Defiende el trono. Cada retador se enfrenta al rey actual una vez.",
    "maxParticipantsHint": "Limita el número de jugadores que pueden unirse",
    "publicTournamentHint": "Cualquiera puede encontrar y unirse a este torneo",
    "unlimited": "Sin límite",
    "creating": "Creando...",
    "dateTime": "Fecha y Hora",
    "admin": "Administrador",
    "viewer": "Espectador",
    "owner": "Propietario",
    "yourRole": "Tu Rol",
    "notSet": "No establecido",
    "tapMapToSetLocation": "Toca el mapa para establecer ubicación",
    "saveLocation": "Guardar Ubicación",
    "editLocation": "Editar Ubicación",
    "addLocation": "Añadir Ubicación",
    "openInMaps": "Abrir en Mapas",
    "locationPlaceholder": "Nombre del lugar (ej. Parque Central)",
    "startDateTime": "Fecha y Hora de Inicio",
    "saveDate": "Guardar Fecha",
    "editDate": "Editar Fecha",
    "addDate": "Añadir Fecha",
    "publicTournamentDesc": "Cualquiera con el enlace puede ver este torneo",
    "inviteParticipants": "Invitar Participantes",
    "shareInviteDesc": "Comparte este enlace para invitar a personas a tu torneo",
    "shareInviteLink": "Compartir Enlace de Invitación",
    "copyLink": "Copiar Enlace",
    "noRulesYet": "Aún no se han establecido reglas",
    "noRulesSubtext": "Añade reglas para ayudar a los participantes a entender el formato del torneo",
    "rulesPlaceholder": "Introduce las reglas del torneo...",
    "saveRules": "Guardar Reglas",
    "editRules": "Editar Reglas",
    "addRules": "Añadir Reglas",
    "addAdmin": "Añadir Admin",
    "noAdminsYet": "Aún no hay administradores",
    "noAdminsSubtext": "Añade colaboradores para ayudar a gestionar este torneo",
    "onlyOwnerCanManageAdmins": "Solo el propietario del torneo puede gestionar administradores",
    "addAdministrator": "Añadir Administrador",
    "enterEmailForAdmin": "Introduce el email del usuario que quieres añadir como administrador",
    "selectRole": "Seleccionar Rol",
    "adminRoleDesc": "Puede gestionar participantes y actualizar resultados",
    "viewerRoleDesc": "Solo puede ver el torneo (solo lectura)",
    "enterEmailForParticipant": "Introduce el email de un usuario registrado para añadirlo como participante",
    "searchByNameOrEmail": "Busca por nombre o email para añadirlo como participante",
    "searchNameOrEmailPlaceholder": "Nombre o email…",
    "invalidParticipantCountWarning": "⚠️ Número de participantes inválido. Necesita potencia de 2 (2, 4, 8, 16...). Actualmente: {{count}}",
    "noParticipants": "Aún no hay participantes",
    "participantName": "Nombre del participante",
    "enterEmail": "Introduce correo electrónico",
    "searchByEmail": "Nombre o correo",
    "manual": "Manual",
    "removeParticipant": "Quitar Participante",
    "confirmRemoveParticipant": "¿Estás seguro de que quieres quitar a este participante?",
    "type": "Tipo"
  },
  "social": {
    "friends": "Amigos",
    "friend": "Amigo",
    "addFriend": "Añadir Amigo",
    "removeFriend": "Eliminar Amigo",
    "friendRequest": "Solicitud de Amistad",
    "friendRequests": "Solicitudes de Amistad",
    "pendingRequests": "Solicitudes Pendientes",
    "sendFriendRequest": "Enviar Solicitud de Amistad",
    "acceptRequest": "Aceptar",
    "declineRequest": "Rechazar",
    "cancelRequest": "Cancelar Solicitud",
    "requestSent": "¡Solicitud de amistad enviada!",
    "requestAccepted": "¡Solicitud de amistad aceptada!",
    "requestDeclined": "Solicitud de amistad rechazada",
    "alreadyFriends": "Ya sois amigos",
    "noFriendsYet": "Aún no tienes amigos",
    "noRequestsYet": "No hay solicitudes de amistad",
    "noPendingRequests": "No hay solicitudes pendientes",
    "whenReceiveRequestsAppear": "Cuando recibas solicitudes de amistad, aparecerán aquí.",
    "requestCount": "{{count}} solicitudes",
    "requestCountSingular": "{{count}} solicitud",
    "followers": "Seguidores",
    "following": "Siguiendo",
    "follow": "Seguir",
    "unfollow": "No seguir",
    "noFollowersYet": "Aún no tienes seguidores",
    "notFollowingAnyone": "Aún no sigues a nadie",
    "challenge": "Desafiar",
    "challenges": "Desafíos",
    "sendChallenge": "Enviar Desafío",
    "challengeUser": "Desafiar Usuario",
    "addMessage": "Añade un mensaje (opcional)",
    "challengeSent": "¡Desafío enviado!",
    "challengeAccepted": "¡Desafío aceptado!",
    "challengeDeclined": "Desafío rechazado",
    "challengeCancelled": "Desafío cancelado",
    "noChallengesYet": "Aún no hay desafíos",
    "received": "Recibidos",
    "sent": "Enviados",
    "pending": "Pendiente",
    "accepted": "Aceptado",
    "declined": "Rechazado",
    "accept": "Aceptar",
    "decline": "Rechazar",
    "viewTournament": "Ver Torneo",
    "noChallengesReceived": "No hay desafíos recibidos",
    "noChallengesSent": "No hay desafíos enviados",
    "whenChallengedAppear": "Cuando alguien te desafíe, aparecerá aquí.",
    "haventChallengedAnyone": "Aún no has desafiado a nadie.",
    "whenAddFriendsAppear": "Cuando añadas amigos, aparecerán aquí."
  },
  "profile": {
    "profile": "Perfil",
    "myProfile": "Mi Perfil",
    "editProfile": "Editar Perfil",
    "viewProfile": "Ver Perfil",
    "memberSince": "Miembro desde",
    "tournamentsCreated": "Torneos Creados",
    "tournamentsWon": "Torneos Ganados",
    "winRate": "Porcentaje de Victorias",
    "matches": "Partidos",
    "wins": "Victorias",
    "losses": "Derrotas",
    "posts": "Publicaciones",
    "stats": "Estadísticas",
    "championship": "Campeonato",
    "championships": "Campeonatos",
    "tournamentHistory": "Historial de Torneos",
    "noTournamentsYet": "Aún no hay torneos",
    "detailedStatistics": "Estadísticas Detalladas",
    "tournamentsPlayed": "Torneos Jugados",
    "totalWins": "Victorias Totales",
    "totalLosses": "Derrotas Totales",
    "noPostsYet": "Aún no hay publicaciones",
    "requestSent": "Solicitud Enviada",
    "acceptRequest": "Aceptar Solicitud",
    "won": "Ganados",
    "challengesPlayed": "Desafíos Jugados",
    "challengesWon": "Desafíos Ganados",
    "challengeWins": "Victorias en Desafíos"
  },
  "settings": {
    "settings": "Ajustes",
    "appearance": "Apariencia",
    "darkMode": "Modo Oscuro",
    "lightMode": "Modo Claro",
    "language": "Idioma",
    "selectLanguage": "Seleccionar Idioma",
    "notifications": "Notificaciones",
    "pushNotifications": "Notificaciones Push",
    "pushNotificationsEnabled": "Activadas",
    "pushNotificationsEnable": "Activar",
    "pushNotificationsOpenSettings": "Abrir Ajustes",
    "emailNotifications": "Notificaciones por Correo",
    "account": "Cuenta",
    "changePassword": "Cambiar Contraseña",
    "deleteAccount": "Eliminar Cuenta",
    "deleteAccountWarning": "Esto eliminará permanentemente tu cuenta y todos tus datos. Esta acción no se puede deshacer.",
    "deleteAccountConfirm": "Eliminar permanentemente",
    "about": "Acerca de",
    "version": "Versión",
    "termsOfService": "Términos de Servicio",
    "privacyPolicy": "Política de Privacidad",
    "helpSupport": "Ayuda y Soporte",
    "contactUs": "Contáctanos",
    "rateApp": "Valorar App",
    "other": "Otros",
    "social": "Social"
  },
  "feed": {
    "feed": "Actividad",
    "newPost": "Nueva Publicación",
    "createPost": "Crear Publicación",
    "whatsOnYourMind": "¿Qué estás pensando?",
    "post": "Publicar",
    "posting": "Publicando...",
    "postCreated": "¡Publicación creada!",
    "failedToPost": "Error al crear la publicación",
    "noPostsYet": "Aún no hay publicaciones",
    "followUsersToSeePosts": "¡Sigue a usuarios para ver sus publicaciones!",
    "deletePost": "Eliminar Publicación",
    "deletePostConfirm": "¿Estás seguro de que quieres eliminar esta publicación?",
    "linkTournament": "Vincular Torneo",
    "selectTournament": "Seleccionar Torneo",
    "charactersRemaining": "caracteres restantes",
    "like": "Me gusta",
    "unlike": "Ya no me gusta",
    "likes": "me gusta",
    "oneLike": "me gusta",
    "victoryPost": "¡He ganado el torneo \"{{tournamentName}}\"!",
    "sharePost": "Compartir publicación",
    "linkCopied": "Enlace copiado al portapapeles"
  },
  "post": {
    "screenTitle": "Publicación",
    "notFound": "Esta publicación no está disponible públicamente",
    "notPublicSubtext": "El torneo asociado a esta publicación puede ser privado o ya no existir",
    "openInApp": "Abrir en la app",
    "openInAppCta": "Ver esta publicación en Tournaly",
    "downloadApp": "Descargar Tournaly",
    "ctaTitle": "Únete a Tournaly",
    "ctaSubtitle": "Organiza torneos, compite y conecta con otros jugadores.",
    "ctaSignUp": "Crear cuenta gratis"
  },
  "explore": {
    "explore": "Explorar",
    "exploreTournaments": "Explorar Torneos",
    "discover": "Descubrir",
    "searchPublicTournaments": "Buscar torneos públicos...",
    "discoverTournaments": "Descubrir Torneos",
    "noPublicTournaments": "Aún no hay torneos públicos",
    "tryDifferentSearch": "Prueba con otro término de búsqueda",
    "beFirstToCreate": "¡Sé el primero en crear un torneo público!",
    "loginToSeeFollowed": "Inicia sesión para ver torneos seguidos",
    "signInToFollow": "Inicia sesión para seguir y hacer seguimiento de tus torneos favoritos",
    "noFollowedTournaments": "Aún no sigues ningún torneo",
    "exploreAndFollow": "Explora y sigue torneos para verlos aquí"
  },
  "search": {
    "searchUsers": "Buscar Usuarios",
    "searchPlaceholder": "Buscar por nombre o correo...",
    "noUsersFound": "No se encontraron usuarios",
    "tryDifferentSearch": "Prueba a buscar con otro nombre o correo.",
    "searchForUsers": "Buscar usuarios",
    "minCharacters": "Introduce al menos 2 caracteres para buscar usuarios por nombre o correo."
  },
  "errors": {
    "somethingWentWrong": "Algo salió mal",
    "tryAgain": "Por favor, inténtalo de nuevo",
    "networkError": "Error de red. Comprueba tu conexión.",
    "unauthorized": "No tienes permiso para realizar esta acción",
    "notFound": "No encontrado",
    "serverError": "Error del servidor. Por favor, inténtalo más tarde.",
    "validationError": "Por favor, revisa tus datos",
    "requiredField": "Este campo es obligatorio",
    "invalidEmail": "Dirección de correo inválida",
    "passwordTooShort": "La contraseña debe tener al menos 6 caracteres",
    "failedToLoad": "Error al cargar los datos",
    "deleteAccountFailed": "No se pudo eliminar la cuenta. Por favor, inténtalo de nuevo.",
    "rateLimitAuth": "Por favor espera un momento antes de intentarlo de nuevo.",
    "emailAlreadyRegistered": "Este correo ya está registrado. Intenta iniciar sesión."
  },
  "alerts": {
    "enterTournamentName": "Por favor, introduce un nombre para el torneo",
    "mustBeLoggedIn": "Debes iniciar sesión para realizar esta acción",
    "cannotEditNotSetup": "El torneo solo se puede editar durante la fase de configuración",
    "confirmDeleteTournament": "¿Estás seguro de que quieres eliminar este torneo? Esta acción no se puede deshacer.",
    "needMinParticipants": "Necesitas al menos 2 participantes para iniciar el torneo",
    "confirmStartTournament": "¿Generar cuadro para {{count}} participantes? Esta acción no se puede deshacer.",
    "bracketGenerated": "¡Cuadro del torneo generado!",
    "failedToGenerateBracket": "Error al generar el cuadro",
    "locationUpdated": "Ubicación actualizada correctamente",
    "dateUpdated": "Fecha actualizada correctamente",
    "rulesUpdated": "Reglas actualizadas correctamente",
    "userNotFound": "No se encontró ningún usuario con ese correo electrónico",
    "userNotFoundRegistered": "No se encontró ningún usuario registrado con ese correo electrónico",
    "adminAdded": "{{email}} añadido como administrador",
    "participantAdded": "{{email}} añadido como participante",
    "adminRemoved": "Administrador eliminado",
    "cannotAddStarted": "No se pueden añadir participantes después de iniciar el torneo",
    "cannotDeleteStarted": "No se pueden eliminar participantes después de iniciar el torneo",
    "confirmDeleteParticipant": "¿Eliminar a {{name}} del torneo?",
    "linkCopied": "Enlace de invitación copiado al portapapeles",
    "tournamentNowPublic": "El torneo ahora es público. Cualquiera con el enlace puede verlo.",
    "tournamentNowPrivate": "El torneo ahora es privado. Solo tú y los administradores invitados pueden verlo.",
    "viewOnly": "Tienes acceso de solo lectura a este torneo",
    "matchCompleted": "Este partido ya ha sido completado.",
    "matchWaiting": "Este partido está esperando a participantes de partidos anteriores.",
    "selectWinner": "Por favor, selecciona un ganador",
    "tournamentComplete": "¡Torneo Completado!",
    "weHaveChampion": "¡Tenemos un campeón!",
    "matchResultUpdated": "Resultado del partido actualizado",
    "exportOptions": "Exportar cuadro como PDF o Imagen",
    "bracketExported": "Cuadro exportado correctamente",
    "imageSaved": "Cuadro guardado en tu galería de fotos",
    "permissionDenied": "No se pudo guardar en la galería de fotos",
    "failedToExport": "Error al exportar el cuadro",
    "useExportPDFOnWeb": "La exportación de imagen no está disponible en web. Por favor, usa la opción de exportar PDF.",
    "popupBlocked": "La ventana emergente fue bloqueada. Por favor, permite las ventanas emergentes e inténtalo de nuevo.",
    "postContentRequired": "El contenido de la publicación es obligatorio",
    "maxCharactersExceeded": "El contenido debe tener 500 caracteres o menos",
    "postCreated": "¡Publicación creada correctamente!",
    "postDeleted": "Publicación eliminada correctamente",
    "discardPost": "¿Descartar publicación?",
    "discardPostConfirm": "¿Estás seguro de que quieres descartar esta publicación?",
    "friendRemoved": "Amigo eliminado correctamente",
    "confirmRemoveFriend": "¿Eliminar a {{name}} de tus amigos?",
    "friendRequestAccepted": "Solicitud de amistad aceptada",
    "friendRequestDeclined": "Solicitud de amistad rechazada",
    "challengeAcceptedTournament": "¡Desafío aceptado! Torneo creado.",
    "challengeDeclined": "Desafío rechazado",
    "followSuccess": "Siguiendo correctamente",
    "unfollowSuccess": "Has dejado de seguir",
    "requestPending": "Tu solicitud de amistad está pendiente",
    "alreadyFriends": "Ya sois amigos",
    "challengeSent": "¡Desafío enviado!",
    "enterEmail": "Por favor, introduce una dirección de correo electrónico",
    "enterParticipantName": "Por favor, introduce el nombre del participante",
    "fillAllFields": "Por favor, rellena todos los campos",
    "passwordsNotMatch": "Las contraseñas no coinciden",
    "passwordMinLength": "La contraseña debe tener al menos 6 caracteres",
    "enterEmailPassword": "Por favor, introduce el correo y la contraseña",
    "registrationFailed": "Error de Registro",
    "checkEmailVerify": "Por favor, revisa tu correo para verificar tu cuenta",
    "photoUploaded": "Foto subida correctamente. ¡Recuerda hacer clic en Guardar Cambios!",
    "profileUpdated": "Perfil actualizado correctamente",
    "discard": "Descartar",
    "keep": "Seguir Editando",
    "leagueParticipantAdded": "Participante añadido a la liga",
    "leagueParticipantRemoved": "Participante eliminado de la liga",
    "tournamentCreatedInLeague": "Torneo creado y participantes añadidos desde la liga"
  },
  "time": {
    "justNow": "Ahora",
    "minutesAgo": "Hace {{count}}m",
    "hoursAgo": "Hace {{count}}h",
    "daysAgo": "Hace {{count}}d"
  },
  "filters": {
    "filtersAndSorting": "Filtros y Ordenar",
    "status": "Estado",
    "type": "Tipo",
    "sortBy": "Ordenar por",
    "applyFilters": "Aplicar Filtros",
    "newestFirst": "Más Recientes",
    "oldestFirst": "Más Antiguos",
    "nameAZ": "Nombre A-Z",
    "nameZA": "Nombre Z-A",
    "single": "Simple",
    "double": "Doble"
  },
  "bracket": {
    "bracket": "Bracket",
    "leaderboard": "Clasificación",
    "posts": "Publicaciones",
    "noPostsForTournament": "Aún no hay publicaciones",
    "beFirstToPost": "¡Sé el primero en compartir sobre este torneo!",
    "allRounds": "Todas las Rondas",
    "allMatches": "Todos los Partidos",
    "pending": "Pendientes",
    "upcoming": "Próximos",
    "completed": "Completados",
    "winnersRound": "R Ganadores",
    "losersRound": "R Perdedores",
    "grandFinal": "Gran Final",
    "grandFinalReset": "Gran Final - Reset",
    "bracketResetNote": "Reset del Bracket - Ambos jugadores tienen 1 derrota",
    "winnersBracket": "Bracket de Ganadores",
    "losersBracket": "Bracket de Perdedores",
    "bracketReset": "Reset del Bracket",
    "singleEliminationBracket": "Bracket Eliminación Simple",
    "doubleEliminationBracket": "Bracket Eliminación Doble",
    "tripleEliminationBracket": "Bracket Triple Eliminación",
    "roundRobinTournament": "Torneo Todos contra Todos",
    "swissSystemTournament": "Torneo Sistema Suizo",
    "kingOfTheHillTournament": "Rey de la Colina",
    "secondLosersBracket": "Bracket Segunda Oportunidad",
    "exportOptions": "Opciones de Exportación",
    "exportOptionsDesc": "Elige cómo quieres compartir el torneo",
    "exportPDF": "Exportar PDF",
    "shareImage": "Compartir Imagen",
    "adminCanUpdate": "Admin - Puede actualizar resultados",
    "viewerReadOnly": "Visor - Solo lectura",
    "standings": "Clasificación",
    "rankings": "Rankings",
    "finalResults": "Resultados Finales",
    "liveRankings": "Rankings en Vivo",
    "enterMatchResult": "Introducir Resultado",
    "pts": "pts",
    "w": "V",
    "l": "D",
    "d": "E",
    "wr": "TV",
    "draw": "Empate",
    "team": "Equipo",
    "played": "J",
    "won": "G",
    "drawn": "E",
    "lost": "P",
    "goalDifference": "DG",
    "points": "Pts",
    "legendSwiss": "J: Jugados • G: Ganados • E: Empates • P: Perdidos • Pts: Puntos",
    "legendRoundRobin": "J: Jugados • G: Ganados • E: Empates • P: Perdidos • DG: Diferencia de Goles • Pts: Puntos",
    "match": "Partido",
    "round": "Ronda",
    "selectWinner": "Seleccionar Ganador:",
    "submitResult": "Enviar Resultado",
    "scoreHint": "Introduce las puntuaciones arriba. El ganador se determinará automáticamente.",
    "equalScoresDraw": "Puntuaciones iguales = Empate",
    "score": "Puntuación"
  },
  "editProfile": {
    "changePhoto": "Cambiar Foto",
    "uploadPhoto": "Subir Foto",
    "fullName": "Nombre Completo",
    "enterFullName": "Introduce tu nombre completo",
    "email": "Correo Electrónico",
    "emailCannotChange": "El correo no se puede cambiar",
    "bio": "Biografía",
    "bioPlaceholder": "Cuéntanos sobre ti...",
    "saveChanges": "Guardar Cambios",
    "saving": "Guardando..."
  },
  "createPost": {
    "photoOptional": "Foto (Opcional)",
    "addPhoto": "Añadir Foto",
    "tournamentOptional": "Torneo (Opcional)",
    "none": "Ninguno",
    "creatingPost": "Creando Publicación..."
  },
  "followers": {
    "noFollowersYet": "Aún no hay seguidores",
    "whenFollowAppear": "Cuando alguien siga esta cuenta, aparecerá aquí.",
    "follower": "seguidor",
    "followers": "seguidores",
    "following": "siguiendo"
  },
  "permissions": {
    "permissionRequired": "Permiso Requerido",
    "photoPermission": "Necesitamos acceso a tus fotos para subir una imagen.",
    "failedToPick": "Error al seleccionar imagen",
    "failedToUpload": "Error al subir",
    "photoUploadSuccess": "¡Foto subida correctamente!"
  },
  "misc": {
    "unknownUser": "Usuario Desconocido"
  },
  "leagues": {
    "league": "Liga",
    "leagues": "Ligas",
    "createLeague": "Crear Liga",
    "editLeague": "Editar Liga",
    "deleteLeague": "Eliminar Liga",
    "completeLeague": "Completar Liga",
    "leagueName": "Nombre de la Liga",
    "description": "Descripción",
    "pointSystem": "Sistema de Puntos",
    "pointSystemDesc": "Puntos otorgados según la posición final en cada torneo",
    "customPoints": "Puntos Personalizados",
    "tournaments": "Torneos",
    "participants": "Participantes",
    "leaderboard": "Clasificación",
    "settings": "Ajustes",
    "createTournament": "Crear Torneo en la Liga",
    "noLeaguesYet": "Aún no hay ligas",
    "createFirstLeague": "¡Crea tu primera liga para organizar una serie de torneos!",
    "noTournamentsInLeague": "Aún no hay torneos en esta liga",
    "addTournamentToStart": "Añade un torneo para iniciar la liga",
    "noStandingsYet": "Aún no hay clasificación. Completa un torneo para ver la tabla.",
    "leagueCreated": "¡Liga creada!",
    "leagueUpdated": "¡Liga actualizada!",
    "leagueDeleted": "¡Liga eliminada!",
    "leagueCompleted": "¡Liga completada!",
    "failedToCreate": "Error al crear la liga",
    "failedToLoad": "Error al cargar la liga",
    "failedToDelete": "Error al eliminar la liga",
    "confirmDeleteLeague": "¿Estás seguro de que quieres eliminar esta liga? Los torneos no se eliminarán pero se desvincularán.",
    "confirmCompleteLeague": "¿Marcar esta liga como completada? Todos los torneos deben estar completados primero.",
    "notAllTournamentsCompleted": "Todos los torneos deben estar completados antes de poder completar la liga.",
    "leagueNotFound": "Liga no encontrada",
    "totalPoints": "Puntos Totales",
    "position": "Posición",
    "pointsAwarded": "Puntos",
    "setup": "Configuración",
    "active": "Activa",
    "completed": "Completada",
    "f1Style": "Estilo F1 (25, 18, 15, 12, 10, 8, 6, 4, 2, 1)",
    "linear": "Lineal (10, 8, 6, 5, 4, 3, 2, 1)",
    "winnerTakesAll": "El Ganador se Lleva Todo (3, 1)",
    "custom": "Personalizado",
    "enterCustomPoints": "Introduce puntos separados por comas (ej., 10, 7, 5, 3, 1)",
    "participantsLocked": "Los participantes están bloqueados después de que la liga haya comenzado",
    "tournamentsCompleted": "torneos completados",
    "tournamentsPlayed": "jugados",
    "nameRequired": "El nombre de la liga es obligatorio",
    "invalidPointSystem": "Introduce valores de puntos válidos separados por comas",
    "champion": "Campeón de la Liga",
    "visibility": "Visibilidad",
    "public": "Pública",
    "private": "Privada",
    "publicDesc": "Cualquiera puede descubrir y ver esta liga",
    "privateDesc": "Solo tú puedes ver esta liga",
    "publicTournamentsWarning": "Hacer pública la liga también hará públicos todos sus torneos",
    "exploreLeagues": "Explorar Ligas",
    "noPublicLeagues": "No se encontraron ligas públicas",
    "discoverLeagues": "Descubrir ligas públicas",
    "logo": "Logo de la liga",
    "uploadLogo": "Subir logo",
    "changeLogo": "Cambiar logo",
    "logoOptional": "Opcional"
  },
  "status": {
    "challengeStatus": {
      "pending": "Pendiente",
      "accepted": "Aceptado",
      "declined": "Rechazado"
    },
    "tournamentStatus": {
      "setup": "Configuración",
      "in_progress": "En Progreso",
      "completed": "Completado"
    }
  },
  "notifications": {
    "title": "Notificaciones",
    "markAllRead": "Marcar todo como leído",
    "empty": "No hay notificaciones aún",
    "preferences": "Notificaciones",
    "tournamentStarted": "Torneo Iniciado",
    "tournamentStartedBody": "¡{{name}} ha comenzado! Revisa el bracket.",
    "tournamentInvitation": "Invitación a Torneo",
    "tournamentInvitationBody": "Te han añadido a {{name}}.",
    "friendRequest": "Solicitud de Amistad",
    "friendRequestBody": "{{name}} te envió una solicitud de amistad.",
    "challengeReceived": "Desafío Recibido",
    "challengeReceivedBody": "¡{{name}} te ha desafiado!",
    "matchResult": "Resultado de Partido",
    "matchResultBody": "Se actualizó un resultado en {{name}}.",
    "tournamentCompleted": "Torneo Completado",
    "tournamentCompletedBody": "¡{{name}} tiene un campeón!",
    "leagueInvitation": "Invitación a Liga",
    "leagueInvitationBody": "Te han añadido a la liga {{name}}.",
    "type_tournament_started": "Torneo Iniciado",
    "type_tournament_invitation": "Invitación a Torneo",
    "type_friend_request": "Solicitud de Amistad",
    "type_challenge_received": "Desafío Recibido",
    "type_match_result": "Resultado de Partido",
    "type_tournament_completed": "Torneo Completado",
    "type_league_invitation": "Invitación a Liga"
  },
  "moderation": {
    "contentBlocked": "Este contenido no cumple con nuestras normas de la comunidad. Por favor, revísalo e inténtalo de nuevo.",
    "imageBlocked": "Esta imagen no cumple con nuestras normas de la comunidad. Por favor, elige otra imagen.",
    "cooldownActive": "Estás temporalmente restringido de publicar. Por favor, inténtalo más tarde."
  },
  "invitations": {
    "tournamentInvitations": "Invitaciones a Torneos",
    "inviteByEmail": "Invitar por Email",
    "inviteByEmailDesc": "Busca un usuario registrado por email y envíale una invitación para unirse a este torneo.",
    "inviteCode": "Código de Invitación",
    "inviteCodeDesc": "Genera un código que cualquiera puede usar para unirse a este torneo.",
    "generateCode": "Generar Código",
    "codeGenerated": "¡Código de invitación generado!",
    "joinByCode": "Unirse por Código",
    "enterCode": "Ingresa el código",
    "enterCodeSubtitle": "Ingresa el código de invitación compartido por el organizador del torneo para unirte.",
    "join": "Unirse",
    "sendInvitation": "Enviar Invitación",
    "invitationSent": "¡Invitación enviada!",
    "invitationAccepted": "¡Invitación aceptada! Has sido añadido al torneo.",
    "invitationDeclined": "Invitación rechazada",
    "invitationCancelled": "Invitación cancelada",
    "alreadyInvited": "Este usuario ya ha sido invitado",
    "alreadyParticipant": "Este usuario ya es participante",
    "tournamentNotSetup": "El torneo ya no acepta participantes",
    "tournamentFull": "El torneo está lleno",
    "invalidCode": "Código de invitación inválido",
    "codeCopied": "¡Código de invitación copiado!",
    "optionalMessage": "Agregar un mensaje (opcional)",
    "shareCodeMessage": "¡Únete a \"{{name}}\" en Tournaly! Usa el código: {{code}}",
    "noInvitationsReceived": "No hay invitaciones recibidas",
    "noInvitationsSent": "No hay invitaciones enviadas",
    "whenInvitedAppear": "Cuando alguien te invite a un torneo, aparecerá aquí.",
    "haventInvitedAnyone": "Aún no has invitado a nadie a un torneo.",
    "status": {
      "pending": "Pendiente",
      "accepted": "Aceptada",
      "declined": "Rechazada",
      "cancelled": "Cancelada"
    }
  },
  "ads": {
    "sponsoredContent": "Patrocinado"
  },
  "subscription": {
    "pro": "Pro",
    "free": "Gratis",
    "unlimited": "Ilimitado",
    "upgradeToPro": "Tournaly Pro",
    "manageSubscription": "Mi suscripcion",
    "monthly": "Mensual",
    "yearly": "Anual",
    "monthlyPrice": "€4,99/mes",
    "yearlyPrice": "€39,99/año",
    "yearlyPerMonth": "€3,33/mes",
    "yearlySavings": "Ahorra 33%",
    "restorePurchases": "Restaurar compras",
    "subscribe": "Suscribirse",
    "choosePlan": "Elige tu plan",
    "whatsIncluded": "Que incluye",
    "paywallSubtitle": "Desbloquea torneos ilimitados, todos los formatos y mas",
    "youArePro": "Eres Pro!",
    "proDescription": "Tienes acceso a todas las funciones Pro. Gracias por tu apoyo!",
    "renewsOn": "Se renueva el {{date}}",
    "featureLocked": "Funcion Pro",
    "tournamentLimitReached": "Has alcanzado el maximo de 3 torneos activos. Actualiza a Pro para torneos ilimitados.",
    "privateTournamentLimitReached": "El plan gratuito permite 1 torneo privado. Actualiza a Pro para torneos privados ilimitados.",
    "leagueTournamentLimitReached": "El plan gratuito permite 3 torneos activos por liga. Actualiza a Pro para torneos de liga ilimitados.",
    "planLimitReached": "Has alcanzado un límite del plan gratuito. Actualiza a Pro para continuar.",
    "participantLimitReached": "El plan gratuito soporta hasta 16 participantes por torneo.",
    "leagueLimitReached": "Has alcanzado el maximo de 1 liga activa. Actualiza a Pro para ligas ilimitadas.",
    "tournamentTypeProOnly": "Los formatos Doble Eliminación, Suizo, Triple Eliminación y Rey de la Colina están disponibles con Pro.",
    "pdfExportProOnly": "La exportacion a PDF esta disponible con Pro.",
    "success": "Exito",
    "welcomePro": "Bienvenido a Tournaly Pro! Todas las funciones estan desbloqueadas.",
    "error": "Error",
    "noOfferings": "No se pudieron cargar las opciones de suscripcion. Intenta de nuevo mas tarde.",
    "purchaseFailed": "No se pudo completar la compra. Intenta de nuevo.",
    "restoreSuccess": "Compras restauradas! Tu suscripcion Pro esta activa.",
    "restoreFailed": "No se pudieron restaurar las compras. Intenta de nuevo.",
    "noSubscriptionFound": "No se encontro una suscripcion activa para esta cuenta.",
    "legalText": "El pago se cargara a tu cuenta de App Store o Google Play. La suscripcion se renueva automaticamente a menos que se cancele al menos 24 horas antes del final del periodo actual.",
    "webCheckoutRedirect": "Serás redirigido a nuestra página de pago segura para completar tu suscripción.",
    "restoreNotAvailableWeb": "Las compras se gestionan a través de tu proveedor de pago. Si tienes una suscripción activa, se reflejará aquí automáticamente.",
    "proFeatures": {
      "unlimitedTournaments": "Torneos activos ilimitados",
      "unlimitedParticipants": "Hasta 512 participantes por torneo",
      "allFormats": "Todos los formatos (incl. Doble Eliminación, Suizo y Triple Eliminación)",
      "unlimitedLeagues": "Ligas ilimitadas",
      "pdfExport": "Exportar bracket a PDF",
      "noWatermark": "Sin marca de agua en exportaciones",
      "noAds": "Sin anuncios",
      "proBadge": "Insignia Pro en tu perfil"
    },
    "comparison": {
      "title": "Gratis vs Pro",
      "feature": "Funcion",
      "activeTournaments": "Torneos activos",
      "participants": "Participantes/torneo",
      "tournamentTypes": "Tipos de torneo",
      "allTypes": "Los 6 tipos",
      "allTypesDetail": "• Eliminación Simple\n• Eliminación Doble\n• Triple Eliminación\n• Round Robin\n• Suizo\n• Rey de la Colina",
      "activeLeagues": "Ligas activas",
      "privateTournaments": "Torneos privados",
      "pdfExport": "Exportar PDF",
      "watermark": "Marca de agua",
      "ads": "Anuncios"
    }
  },
  "feedback": {
    "subtitle": "Tu opinión nos ayuda a mejorar Tournaly. Informa de errores, sugiere funciones o comparte lo que piensas.",
    "typeLabel": "Tipo",
    "type": {
      "bug": "Error",
      "feature": "Idea",
      "general": "General"
    },
    "messageLabel": "Mensaje",
    "messagePlaceholder": "Describe tu feedback con detalle...",
    "submit": "Enviar Feedback",
    "submitting": "Enviando...",
    "successTitle": "¡Gracias!",
    "successMessage": "Tu feedback ha sido recibido. Leemos todos los mensajes."
  },
  "onboarding": {
    "slide1Title": "Crea tu torneo",
    "slide1Subtitle": "Organiza torneos de eliminación, round robin o suizos. Tú decides el formato.",
    "slide2Title": "Conecta con amigos",
    "slide2Subtitle": "Síguelos, lánzales retos 1v1 y comparte tus victorias.",
    "slide3Title": "Equipos y ligas",
    "slide3Subtitle": "Crea o únete a un equipo, compite junto en torneos y escala la clasificación de la liga.",
    "next": "Siguiente",
    "skip": "Omitir",
    "createTournament": "Crear mi primer torneo",
    "exploreTournaments": "Explorar torneos",
    "notifTitle": "Mantente al tanto",
    "notifSubtitle": "Recibe avisos cuando se jueguen partidos, tus amigos te reten y tus torneos comiencen.",
    "notifEnable": "Activar notificaciones",
    "notifLater": "Quizás más tarde"
  },
  "landing": {
    "tagline": "Gestiona torneos. Registra resultados. Conecta con jugadores.",
    "getStartedFree": "Empezar gratis",
    "signIn": "Iniciar sesión",
    "downloadApp": "También disponible en móvil",
    "downloadOnAppStore": "Descargar en el App Store",
    "getItOnGooglePlay": "Disponible en Google Play",
    "features": {
      "title": "Todo lo que necesitas para organizar tus torneos",
      "bracketsTitle": "Generación de brackets",
      "bracketsDesc": "6 formatos: Eliminación simple, doble y triple, Round Robin, Suizo, King of the Hill — generados automáticamente en segundos.",
      "participantsTitle": "Gestión de participantes",
      "participantsDesc": "Añade jugadores manualmente o invita usuarios registrados por email o código.",
      "standingsTitle": "Clasificaciones en vivo",
      "standingsDesc": "Tablas y resultados actualizados en tiempo real a medida que se juegan los partidos.",
      "socialTitle": "Funciones sociales",
      "socialDesc": "Sigue jugadores, envía desafíos 1v1, comparte posts de victoria y crea tu comunidad.",
      "leaguesTitle": "Ligas",
      "leaguesDesc": "Crea ligas públicas o privadas con sistemas de puntos personalizados (F1, lineal, winner-takes-all…) y lleva el seguimiento entre torneos.",
      "teamsTitle": "Equipos",
      "teamsDesc": "Crea o únete a un equipo con tu grupo. Invita jugadores, gestiona tu plantilla y compite juntos.",
      "mobileTitle": "Apps móviles",
      "mobileDesc": "Disponible en iOS y Android. Gestiona tus torneos desde cualquier lugar.",
      "exportTitle": "Exportar y compartir",
      "exportDesc": "Exporta brackets en PDF o PNG. Genera códigos QR y links para cualquier torneo. Envía invitaciones por email en un toque.",
      "inviteTitle": "Códigos de invitación",
      "inviteDesc": "Comparte un código único de 8 caracteres — los jugadores se unen al instante sin necesidad de registrarse.",
      "exploreTitle": "Explorar y descubrir",
      "exploreDesc": "Navega por torneos y ligas públicas. Sigue torneos para recibir notificaciones de cada resultado."
    },
    "screenshots": {
      "title": "Vélo en acción",
      "tournamentList": "Lista de torneos",
      "bracketView": "Vista de bracket",
      "leaderboard": "Clasificación",
      "tournamentListTitle": "Todos tus torneos",
      "tournamentListDesc": "Gestiona y sigue todos tus torneos activos desde una vista limpia.",
      "bracketViewTitle": "Bracket en vivo",
      "bracketViewDesc": "Sigue cómo evoluciona el bracket en tiempo real conforme se juegan los partidos.",
      "leaderboardTitle": "Clasificación en vivo",
      "leaderboardDesc": "Tabla actualizada automáticamente con cada resultado.",
      "socialSubtitle": "Hecho para competidores que juegan juntos",
      "challenges": "Desafíos",
      "challengesTitle": "Desafíos 1v1",
      "challengesDesc": "Desafía a un amigo a un torneo cara a cara. Acepta, compite y demuestra quién es mejor.",
      "friends": "Amigos",
      "friendsTitle": "Amigos y seguidores",
      "friendsDesc": "Construye tu círculo, sigue a otros jugadores y mantente conectado en cada competición.",
      "feed": "Feed",
      "feedTitle": "Feed social",
      "feedDesc": "Entérate de resultados, posts de victoria y momentos destacados de todos los que sigues."
    },
    "heroTitle": "El gestor de torneos",
    "heroTitleAccent": "para todo el mundo",
    "pricing": {
      "title": "Precios simples y transparentes",
      "forever": "Para siempre"
    },
    "footer": {
      "cta": "¿Listo para crear tu primer torneo?",
      "privacy": "Política de privacidad",
      "terms": "Términos de servicio",
      "copyright": "Todos los derechos reservados."
    }
  },
  "welcome": {
    "headline": "El gestor de torneos\npara todo el mundo",
    "feature1": "6 formatos: SE, DE, Triple Elim, Round Robin, Suizo, Rey de la Colina",
    "feature2": "Equipos, ligas, clasificaciones y tablas",
    "feature3": "Reta a amigos y comparte resultados",
    "getStarted": "Empezar gratis",
    "alreadyHaveAccount": "¿Ya tienes cuenta?",
    "signIn": "Iniciar sesión"
  },
  "home": {
    "welcomeBack": "¡Bienvenido, {{name}}!",
    "pendingActions": "Acciones Pendientes",
    "tournamentInvitationsPending": "{{count}} invitación(es) de torneo pendiente(s)",
    "teamInvitationsPending": "{{count}} invitación(es) de equipo pendiente(s)",
    "friendRequestsPending": "{{count}} solicitud(es) de amistad pendiente(s)",
    "challengesPending": "{{count}} desafío(s) esperando",
    "activeTournaments": "Torneos Activos",
    "myLeagues": "Mis Ligas",
    "recentActivity": "Actividad Reciente",
    "discover": "Descubrir Torneos",
    "seeAll": "Ver todos",
    "explore": "Explorar",
    "noActiveTournaments": "Sin torneos activos",
    "noPublicTournaments": "Aún no hay torneos públicos",
    "createTournament": "Nuevo Torneo",
    "createLeague": "Nueva Liga",
    "gettingStartedTitle": "Comienza con Tournaly",
    "gettingStartedStep1": "Crea tu primer torneo",
    "gettingStartedStep2": "Explora torneos públicos",
    "gettingStartedStep3": "Crea una liga"
  },
  "teams": {
    "team": "Equipo",
    "teams": "Equipos",
    "myTeams": "Mis Equipos",
    "createTeam": "Crear Equipo",
    "editTeam": "Editar Equipo",
    "exploreTeams": "Explorar Equipos",
    "discoverTeams": "Buscar equipos por nombre...",
    "teamName": "Nombre del Equipo",
    "teamNamePlaceholder": "Escribe el nombre del equipo",
    "description": "Descripción",
    "descriptionPlaceholder": "Describe tu equipo (opcional)",
    "members": "Miembros",
    "addMember": "Invitar Miembro",
    "pendingInvitations": "Invitaciones Pendientes",
    "pendingInvitation": "Invitación pendiente",
    "removeMember": "Eliminar Miembro",
    "leaveTeam": "Abandonar Equipo",
    "deleteTeam": "Eliminar Equipo",
    "public": "Público",
    "private": "Privado",
    "publicDesc": "Cualquiera puede descubrir y ver este equipo",
    "visibility": "Visibilidad",
    "captain": "Capitán",
    "member": "Miembro",
    "noTeams": "Sin equipos todavía",
    "noTeamsDesc": "Crea tu primer equipo o espera a recibir una invitación",
    "noPublicTeams": "No se encontraron equipos públicos",
    "noPublicTeamsDesc": "Sé el primero en crear un equipo público",
    "noMembers": "Sin miembros todavía",
    "noMembersDesc": "Invita jugadores a unirse a tu equipo",
    "invitePlayer": "Invitar jugador por email",
    "invitationSent": "Invitación enviada",
    "memberAdded": "Miembro añadido correctamente",
    "memberRemoved": "Miembro eliminado",
    "leftTeam": "Has abandonado el equipo",
    "teamDeleted": "Equipo eliminado",
    "confirmLeave": "¿Estás seguro de que quieres abandonar este equipo?",
    "confirmDelete": "¿Estás seguro de que quieres eliminar este equipo? Esta acción no se puede deshacer.",
    "confirmRemove": "¿Estás seguro de que quieres eliminar a este miembro?",
    "captainCannotLeave": "Eres el capitán del equipo. Elimina el equipo en su lugar.",
    "uploadLogo": "Subir Logo",
    "changeLogo": "Cambiar Logo",
    "save": "Guardar Cambios",
    "settings": "Ajustes",
    "teamInvitationTitle": "Invitaciones de Equipo",
    "invitedToJoin": "Has sido invitado a unirte a {{teamName}}",
    "invitePending": "Invitación pendiente a {{teamName}}",
    "memberCount": "{{count}} miembro",
    "memberCount_plural": "{{count}} miembros",
    "teamSection": "Equipos"
  },
  "deleteAccountPage": {
    "title": "Eliminar tu cuenta",
    "intro": "Eliminar tu cuenta borrará permanentemente todos tus datos de Tournaly, incluyendo tu perfil, torneos, partidas, publicaciones y conexiones sociales.",
    "warning": "Esta acción es irreversible. Una vez eliminados, tus datos no podrán recuperarse.",
    "bullet1": "Tu perfil e información personal",
    "bullet2": "Todos los torneos que creaste o en los que participaste",
    "bullet3": "Tus publicaciones y actividad social",
    "bullet4": "Todos los resultados y clasificaciones",
    "signInToDelete": "Inicia sesión con tus credenciales para proceder con la eliminación.",
    "signedInAs": "Sesión iniciada como",
    "signInAndDelete": "Iniciar sesión para eliminar",
    "successTitle": "Cuenta eliminada",
    "successMessage": "Tu cuenta y todos los datos asociados han sido eliminados permanentemente.",
    "backToApp": "Volver a Tournaly"
  },
  "blog": {
    "title": "Blog",
    "subtitle": "Noticias, actualizaciones y guías del equipo de Tournaly",
    "readMore": "Leer más →",
    "backToBlog": "← Volver al Blog",
    "latestUpdates": "Novedades",
    "viewAllPosts": "Ver todas las publicaciones →",
    "publishedOn": "Publicado el {{date}}"
  },
  "training": {
    "title": "TrainerPass",
    "bestRpm": "Mejor RPM",
    "totalLaunches": "Lanzamientos",
    "avgConsistency": "Consistencia media",
    "avgScore": "Puntuación media",
    "bestSpeed": "Velocidad punta",
    "leaderboardTitle": "Clasificación",
    "leaderboardEmpty": "Sin lanzamientos sincronizados. ¡Conecta TrainerPass para aparecer aquí!",
    "launchMeta": "{{launches}} lanzamientos · {{consistency}}% de consistencia",
    "tabScore": "Puntuación",
    "tabRpm": "RPM",
    "tabConsistency": "Consistencia",
    "tabLaunches": "Lanzamientos",
    "myLaunchesTitle": "Mis Lanzamientos",
    "myLaunchesEmpty": "Aún no hay lanzamientos. Sincroniza TrainerPass para verlos aquí.",
    "launchDate": "{{date}}",
    "rpm": "RPM",
    "score": "Puntuación",
    "consistency": "Consistencia",
    "duration": "Duración",
    "seconds": "{{s}}s"
  }
}
